import {ReactComponent as EnglishIcon} from "../locales/en/en.svg";
import {ReactComponent as GreekIcon} from "../locales/el/el.svg";

export const languageOptions = [
    {value: 'el', label: 'Ελληνικά', icon: <GreekIcon/>},
    {value: 'en', label: 'English', icon: <EnglishIcon/>}
];